export default "__VITE_ASSET__XzMdE7Qn__"